export const menuItems = [
  { href: "/", text: "Home" },
  { href: "/about", text: "About" },
  { href: "/webstore", text: "Webstore" },
  { href: "/services", text: "Services" },
  // { href: "/portfolio", text: "Portfolio" },
  { href: "/blog", text: "Blog" },
  { href: "/contact", text: "Contact" },
];
